import { useState } from "react";
import { useTranslation } from "react-i18next";

export default function FAQContact() {
  const { t } = useTranslation("contact");
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const items = t("faq.items", { returnObjects: true }) as Array<{
    q: string;
    a: string;
  }>;

  return (
    <section className="bg-white py-16 md:py-24 w-full">
      <div className="max-w-[800px] mx-auto px-4 md:px-10">
        <h2 className="font-geist font-bold text-2xl md:text-3xl lg:text-4xl text-brand-text tracking-tight text-center mb-10 md:mb-14">
          {t("faq.h2")}
        </h2>

        <div className="divide-y divide-brand-border border-t border-brand-border">
          {items.map((item, i) => (
            <div key={i}>
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between gap-4 py-5 md:py-6 text-left"
              >
                <span className="font-geist font-semibold text-base md:text-lg text-brand-text">
                  {item.q}
                </span>
                <i
                  className={`ri-arrow-down-s-line w-6 h-6 flex items-center justify-center text-brand-text/60 transition-transform flex-shrink-0 ${
                    openIndex === i ? "rotate-180" : ""
                  }`}
                ></i>
              </button>
              {openIndex === i && (
                <p className="font-geist text-sm md:text-base text-brand-text/70 leading-relaxed pb-5 md:pb-6">
                  {item.a}
                </p>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* FAQPage schema */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: items.map((item) => ({
            "@type": "Question",
            name: item.q,
            acceptedAnswer: {
              "@type": "Answer",
              text: item.a,
            },
          })),
        })}
      </script>
    </section>
  );
}